<app-transcribe (transcriptionResult)="onTextReceived($event)" *appPermissionRequired="'Clinical.Transcribe.Write'"></app-transcribe>
<mat-form-field appearance="fill" color="primary" class="w-100">
  @if (control.hasLabel) {
    <mat-label [style.color]="control.labelColour">{{control.label}}</mat-label>
  }
  <textarea matInput appTextareaJumptext appTextareaAutosize [style.color]="control.valueColour" placeholder="{{control.placeHolder}}" [(ngModel)]="control.value" (ngModelChange)="onValueChanges()" [rows]="5"></textarea>
</mat-form-field>
